import { useState } from "react";
import { toast } from "sonner";
import { Mail, Loader2 } from "lucide-react";
import { Switch } from "./ui/switch";
import { Button } from "./ui/button";
import { api } from "../lib/api";

export const EmailDigestCard = ({ settings }) => {
  const [on, setOn] = useState(settings?.email_daily_digest_enabled !== false);
  const [busy, setBusy] = useState(false);
  const toggle = async (v) => {
    setOn(v);
    try { await api.updateSettings({ email_daily_digest_enabled: v }); toast.success(v ? "تم تفعيل الملخص اليومي" : "تم إيقاف الملخص اليومي"); }
    catch { setOn(!v); toast.error("تعذّر الحفظ"); }
  };
  const sendNow = async () => {
    setBusy(true);
    try { const r = await api.emailDigestNow(); r.sent ? toast.success(`أُرسل الملخص إلى ${r.to}`) : toast.error(r.reason === "no_owner_email" ? "لا يوجد بريد مسجّل للمالك" : r.reason === "http_429" ? "ضغط على خدمة البريد — حاول بعد دقيقة" : "تعذّر الإرسال"); }
    catch (e) { toast.error(e?.response?.data?.detail || "تعذّر الإرسال"); } finally { setBusy(false); }
  };
  return (
    <div className="rounded-xl border border-slate-200 p-3 space-y-2 sm:col-span-2" data-testid="email-digest-card">
      <div className="flex items-center justify-between gap-3">
        <div className="flex items-start gap-2">
          <Mail className="h-4 w-4 mt-0.5 text-sky-600" />
          <div><p className="text-sm font-semibold">الملخص اليومي على بريد المالك</p>
            <p className="text-xs text-slate-500">كل يوم الساعة 5 الفجر: الوثائق المنتهية والقريبة، الحضور، السلف والإجازات المعلّقة</p></div>
        </div>
        <Switch data-testid="email-digest-switch" checked={on} onCheckedChange={toggle} className="data-[state=checked]:bg-sky-600" />
      </div>
      <Button variant="outline" size="sm" data-testid="email-digest-send-now" disabled={busy} onClick={sendNow} className="w-full gap-1.5">
        {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <Mail className="h-4 w-4" />} أرسل ملخص اليوم الآن
      </Button>
    </div>
  );
};
